import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useSystemSettings, defaultSystemSettings } from '../contexts/SystemSettingsContext';

const AboutPage: React.FC = () => {
  const { settings } = useSystemSettings();

  const brandName = settings?.footerBrandName || defaultSystemSettings.footerBrandName;
  const description = settings?.footerDescription || defaultSystemSettings.footerDescription;
  const email = settings?.footerContactEmail || defaultSystemSettings.footerContactEmail;
  const phone = settings?.footerContactPhone || defaultSystemSettings.footerContactPhone;
  const address = settings?.footerContactAddress || defaultSystemSettings.footerContactAddress;

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50/50 to-white py-16 px-4">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">About {brandName}</h1>
        <p className="text-gray-600 mb-6">
          {brandName} is {description}
        </p>
        <div className="space-y-4 text-gray-600">
          <div className="flex items-center gap-3">
            <Mail className="h-5 w-5 text-emerald-600" />
            <span>{email}</span>
          </div>
          <div className="flex items-center gap-3">
            <Phone className="h-5 w-5 text-emerald-600" />
            <span>{phone}</span>
          </div>
          <div className="flex items-center gap-3">
            <MapPin className="h-5 w-5 text-emerald-600" />
            <span>{address}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
